import React from 'react'
import { Form } from 'react-bootstrap'

const sectionOptions = [
  { id: 'professional_voice_recording', label: 'Professional Voice Recording' },
  { id: 'misc_telecom', label: 'Misc' },
  { id: 'misc_credit', label: 'Misc Credit' },
];

const MiscRightContent = ({ selectedSections = [], onToggleSection }) => {
  return (
    <div>
        {sectionOptions.map((section) => (
            <div className="right-tab-section d-flex align-items-center gap-3" key={section.id}>
                <Form.Check
                    type="checkbox"
                    checked={selectedSections.includes(section.id)}
                    onChange={() => onToggleSection?.(section.id)}
                />
                <h3 className='d-flex align-items-center gap-2 mb-0'>
                    <img src="/assets/images/invoice-user-icon.svg" alt="" />
                    <span className='font-16 font-weight-bold heading-color'>{section.label}</span>
                </h3>
            </div>
        ))}
    </div>
  )
}

export default MiscRightContent
